import { ConnectionSection } from './ConnectionSection';
import { FormattedMessage } from 'react-intl';
import { Box, Button, Typography } from '@mui/material';
import { IncomingConnectionItem } from './IncomingConnectionItem';
import { IncomingConnections } from '../hook/useUserConnection';
import { useFetchMoreIncomingConnections } from '../hook/useFetchUserConnection';
import { useConnectionDispatch } from './ConnectionDispatchProvider';
import { LoadingIndicator } from '@xolv-mybrightlink/common';

type IncomingConnectionProps = {
  incomingConnections: IncomingConnections;
};

export const IncomingConnectionSection = ({
  incomingConnections,
}: IncomingConnectionProps) => {
  const { connections, hasMore } = incomingConnections;
  const connectionDispatch = useConnectionDispatch();
  const loadMore = useFetchMoreIncomingConnections(
    incomingConnections,
    connectionDispatch,
  );
  const title = (
    <Typography variant='subtitle1'>
      <FormattedMessage
        id='community.connections.connection-request.title'
        values={{ numOfConnection: connections.length }}
      />
    </Typography>
  );
  const detail = (
    <Box>
      {connections.map((connection) => (
        <IncomingConnectionItem key={connection.guid} connection={connection} />
      ))}
      {hasMore && incomingConnections.loading && <LoadingIndicator />}
      {hasMore && !incomingConnections.loading && (
        <Button onClick={loadMore} variant='text' sx={{ px: 0 }}>
          Load more
        </Button>
      )}
    </Box>
  );
  return <ConnectionSection title={title} detail={detail} />;
};
